<ng-container class="create-project">
  <div style="margin: 10px 10px 10px 10px">

    <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start; margin-left: 20px;">
      <div>
        <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif;">Create Project</h2>
      </div>

    </div>

    <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
         >

      <div style="flex:15%">
        <mat-form-field class="example-full-width">
          <mat-label>Project Name</mat-label>
          <input matInput [(ngModel)]="model.name" />
        </mat-form-field>
      </div>

      <div style="flex:0.5%"></div>

      <div style="flex:21.5%">
        <mat-form-field class="project-description-width" style='width: 100%'>
          <mat-label>Project Description</mat-label>
          <input matInput

                 name="projectDescription"
                 [(ngModel)]="model.description">
        </mat-form-field>
      </div>

      <div style="flex:0.5%"></div>

      <div style="flex:0 0 auto" *ngIf="canCreatePartnerProjects">
        <mat-checkbox label="Vendor Compliance"
                      [(ngModel)]="model.isPartner"
                      name="isPartner"
                      (change)="updateAssignedUsers()">Vendor Compliance
        </mat-checkbox>
      </div>

      <div style="flex:0.5%"></div>
      <div style="flex:0 0 auto; padding-right: 10px;" *ngIf="hasLeveledSubItems">
        <mat-form-field>
          <mat-label>Level</mat-label>
          <mat-select
                      [(ngModel)]="maxLevel"
                      name="maxLEVel"
                      (ngModelChange)="updateLeveledSelection()">
            <mat-option [value]="'L1'">
              L1
            </mat-option>
            <mat-option [value]="'L2'">
              L2
            </mat-option>
            <mat-option [value]="'L3'">
              L3
            </mat-option>
            <mat-option [value]="'L4'">
              L4
            </mat-option>
            <mat-option [value]="'L5'">
              L5
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div style="flex:15%" *ngIf="itProfiles">
        <mat-form-field>
          <mat-label>IT Profile</mat-label>
          <mat-select multiple
                      [(ngModel)]="selectedItProfile"
                      name="maxLEVel"
                      (selectionChange)="updateRecommendedControls()">
            <mat-option [value]="itProfile" *ngFor="let itProfile of itProfiles">
              {{itProfile.name || "Default1"}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div style="flex:15%">
        <mat-form-field>
          <mat-label>Workstreams</mat-label>
          <mat-select
            [(ngModel)]="model.workstreamIds"
            name="workstreamIds" multiple="true">
            <mat-option [value]="workstream.workstreamId" *ngFor="let workstream of workstreams">
              {{workstream.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div style="flex:15%">
        <mat-form-field>
          <mat-label>Action Plan Sets</mat-label>
          <mat-select
            [(ngModel)]="model.actionPlanTemplateSetIds"
            name="actionPlanTemplateSetIds" multiple="true">
            <mat-option [value]="set.id" *ngFor="let set of actionPlanTemplateSets">
              {{set.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div style="flex:15%">
        <mat-form-field>
          <mat-label>ICS Sets</mat-label>
          <mat-select
            [(ngModel)]="model.implementationControlStatementSetIds"
            name="implementationControlStatementSetIds" multiple="true">
            <mat-option [value]="set.id" *ngFor="let set of implementationControlStatementSets">
              {{set.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">

      <div class="form-group"
           style="flex:15%">
        <mat-form-field>
          <mat-label>Managers</mat-label>
          <mat-select [(ngModel)]="assignedClientManagers"
                      name="assignedClientManagers"
                      multiple
                      (ngModelChange)="updateAssignedUsers()">
            <mat-option *ngFor="let clientManager of clientManagers" [value]="clientManager">
              {{getFullName(clientManager)}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div style="flex:0.5%"></div>

      <div class="form-group"
           style="flex:15%">
        <mat-form-field>
          <mat-label>Users</mat-label>
          <mat-select [(ngModel)]="assignedClients"
                      name="assignedClients"
                      multiple
                      (ngModelChange)="updateAssignedUsers()">
            <mat-option *ngFor="let client of clients" [value]="client">
              {{getFullName(client)}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div style="flex:0.5%"></div>

      <div class="form-group"
           style="flex:15%">
        <mat-form-field>
          <mat-label>Advisor Lead</mat-label>
          <mat-select [(ngModel)]="assignedConsultantManagers"
                      name="assignedConsultantManagers"
                      multiple
                      (ngModelChange)="updateAssignedUsers()">
            <mat-select-trigger>
              <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                <span *ngFor="let advisorLead of notTenant(assignedConsultantManagers);let i = index">
                  <span *ngIf="i > 0">, </span><span>{{getFullName(advisorLead)}}</span>
                </span>
              </div>
            </mat-select-trigger>
            <mat-option *ngFor="let advisorLead of advisorLeads" [value]="advisorLead">
              {{getFullName(advisorLead)}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div style="flex:0.5%"></div>

      <div class="form-group"
           style="flex:15%">
        <mat-form-field>
          <mat-label>Advisor Staff</mat-label>
          <mat-select [(ngModel)]="assignedConsultants"
                      name="assignedConsultants"
                      multiple
                      (change)="updateAssignedUsers()">
            <mat-option *ngFor="let advisor of advisors" [value]="advisor">
              {{getFullName(advisor)}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div style="flex:0.5%"></div>

      <div class="form-group"
           style="flex:15%">
        <mat-form-field>
          <mat-label>Assessors</mat-label>
          <mat-select [(ngModel)]="assignedAssessors"
                      name="assignedAssessors"
                      multiple
                      (change)="updateAssignedUsers()">
            <mat-option *ngFor="let assessor of assessors" [value]="assessor">
              {{getFullName(assessor)}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="form-group"
           style="flex:15%">
        <mat-form-field>
          <mat-label>Workstream</mat-label>
          <mat-select [(ngModel)]="assignedWorkstreamUsers"
                      name="assignedWorkstreamUsers"
                      multiple
                      (change)="updateAssignedUsers()">
            <mat-option *ngFor="let workstreamUser of workstreamUsers" [value]="workstreamUser">
              {{getFullName(workstreamUser)}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="form-group"
           style="flex:15%"
           *ngIf="isAutonomyEnabled">
        <mat-form-field>
          <mat-label>Fleet</mat-label>
          <mat-select [(ngModel)]="model.fleetId"
                      name="fleetId">
            <mat-option [value]="null">Standalone</mat-option>
            <mat-option *ngFor="let fleet of fleets" [value]="fleet.fleetId">
              {{fleet.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="form-group"
           style="flex:15%" *ngIf="model.isPartner">
        <mat-form-field>
          <mat-label>Vendors</mat-label>
          <mat-select [(ngModel)]="assignedVendors"
                      name="assignedVendors"
                      multiple
                      (change)="updateAssignedUsers()">
            <mat-option *ngFor="let vendor of vendors" [value]="vendor">
              {{getFullName(vendor)}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!--div class="form-group" style="flex:15%">
        <p-datepicker name="dueDate"
            [inputStyle]="{'width':'150px'}"
            [(ngModel)]="model.dueDate"
            [showIcon]="true"
            readonlyInput="false">
        </p-datepicker>
    </div-->

  </div>

  <div style="display: flex; flex-direction: row;" *ngIf="hasParents">
    <mat-label style="padding-right: 20px; white-space: nowrap;">
      Treatment for Parent Controls:
    </mat-label>
    <div style="flex:0 0 2%"></div>
    <div style="flex:0 0 auto">
      <mat-checkbox
        class="example-margin"
        [checked]="!model.displayParentRows"
        (change)="model.displayParentRows = !$event.checked"
      >
        Hide Display
      </mat-checkbox>
    </div>

    <div style="flex:0 0 2%">
    </div>
    <div style="flex:0 0 auto" *ngIf="model.displayParentRows">
      <mat-label
        style="font-weight: bold; line-height: 24px; height: 24px; vertical-align: bottom; margin-right: 10px; cursor: pointer;"
        (click)="model.isParentContainer = false">Actionable
      </mat-label>
      <mat-slide-toggle
        class="example-margin"
        [(ngModel)]="model.isParentContainer"
      >
        Grouping Only
      </mat-slide-toggle>
    </div>
  </div>

  <ng-container *ngFor="let complianceArea of complianceAreas">
    <p-treeTable [value]="[complianceArea]"
                 exportFilename="projects"
                 #table
                 selectionMode="checkbox"
                 [(selection)]="selectedItems"
                 (selectionChange)="updateLevel()"
    >

      <ng-template pTemplate="header">
        <tr>
          <th>Name</th>
          <th style="width: 80px;" *ngIf="hasRank[complianceArea.complianceAreaId]">
            <mat-checkbox [checked]="low[complianceArea.complianceAreaId]" labelPosition="before"
                          (change)="lowChanged(complianceArea, $event)">Low
            </mat-checkbox>
          </th>
          <th style="width: 80px;" *ngIf="hasRank[complianceArea.complianceAreaId]">
            <mat-checkbox [checked]="medium[complianceArea.complianceAreaId]" labelPosition="before"
                          (change)="mediumChanged(complianceArea, $event)">Medium
            </mat-checkbox>
          </th>
          <th style="width: 80px;" *ngIf="hasRank[complianceArea.complianceAreaId]">
            <mat-checkbox [checked]="high[complianceArea.complianceAreaId]" labelPosition="before"
                          (change)="highChanged(complianceArea, $event)">High
            </mat-checkbox>
          </th>
          <th style="width: 220px;">Due date</th>
          <th style="overflow:visible;width:180px">Owner</th>
          <th style="overflow:visible;width:250px">Frequency</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
        <tr [ttRow]="rowNode" [ttSelectableRow]="rowNode">
          <td>
            <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
            <p-treeTableCheckbox [value]="rowNode"></p-treeTableCheckbox>
            <span style="display: inline-block; width: 20px;"><img src="../../../assets/icon/hammer.svg"
                                                                   *ngIf="selectedItProfile && recommendedControlIds.indexOf(rowNode.node.controlItemId) >= 0"
                                                                   style="width:16px;" /></span>{{rowData.name}}
          </td>
          <td *ngIf="hasRank[complianceArea.complianceAreaId]"><span class="pi pi-check"
                                                                     *ngIf="rowNode.node.isLow"></span></td>
          <td *ngIf="hasRank[complianceArea.complianceAreaId]"><span class="pi pi-check"
                                                                     *ngIf="rowNode.node.isMedium"></span></td>
          <td *ngIf="hasRank[complianceArea.complianceAreaId]"><span class="pi pi-check"
                                                                     *ngIf="rowNode.node.isHigh"></span></td>
          <td>
            <mat-form-field class="date-row">
              <input matInput
                     [matDatepicker]="picker"
                     [(ngModel)]="rowData.dueDate"
                     name="nodeDueDate"
                     (dateChange)="onNodeDateChanged('change', $event, rowNode.node)">

              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </td>

          <td>
            <mat-select placeholder="Select client"
                        [(ngModel)]="rowData.assignedClientList"
                        multiple
                        (selectionChange)="onNodeClientChanged($event, $event.value, rowNode.node)">
              <mat-option *ngFor="let user of assignedUsersWithoutPartners" [value]="user">
                {{user.fullName}}
              </mat-option>
              <mat-option (click)="selectAllPartners($event, rowNode.node)" disabled="true" value="-1"
                          class="no-checkbox" *ngIf="model.isPartner">
                <div style="font-weight: bold">Vendor Users</div>
              </mat-option>
              <mat-option *ngFor="let user of assignedVendors" [value]="user">
                <div style="margin-left: 20px">{{user.fullName}}</div>
              </mat-option>
            </mat-select>
          </td>
          <td>
            <p-select [options]="recurringList"
                        [(ngModel)]="rowData.recurring"
                        optionLabel="label"
                        [style]="{'overflow':'visible', 'width':'100%'}"
                        (onChange)="onNodeRecurringChanged($event, $event.value, rowNode.node)">
            </p-select>
            <!--mat-form-field class="date-row"
                            *ngIf='rowData != null && rowData.startDate != null'>
              <input matInput
                     [matDatepicker]="picker"
                     [(ngModel)]="rowData.startDate"
                     name="nodeStartDate"
                     (dateChange)="onNodeStartDateChanged('change', $event, rowNode.node)">

              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field-->
          </td>
        </tr>
      </ng-template>
    </p-treeTable>
  </ng-container>

  <div class="form-group" style="margin-top: 15px;">
    <button mat-raised-button [disabled]="loading" style="border-radius: 6px;" (click)="onCreate()">Create</button>
    <img *ngIf="loading"
         src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
    <button mat-raised-button style="border-radius: 6px;" [routerLink]="['/projects']">Cancel</button>
  </div>
</ng-container>
